import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aabe778"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-nav" }, null, -1))
const _hoisted_2 = { class: "pro-nav-router" }
const _hoisted_3 = { class: "absolute inset-x-0 bottom-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-nav" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoIcon = _resolveComponent("LogoIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_chevron_double_right_icon = _resolveComponent("chevron-double-right-icon")!
  const _component_logout_icon = _resolveComponent("logout-icon")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([_ctx.isLoginPage ? 'hidden' : ''])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pro-transition", _ctx.isExpand ? 'pro-nav' : 'pro-nav-expanded']),
      onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFullNav && _ctx.toggleFullNav(...args))),
      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFullNav && _ctx.toggleFullNav(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full", [_ctx.isHover ? 'h-44' : 'h-8', 'transition-[height] pro-transition-text']])
      }, [
        _createVNode(_component_LogoIcon, {
          class: _normalizeClass(['w-full'])
        }),
        _createElementVNode("p", {
          class: _normalizeClass([
            _ctx.isHover ? 'opacity-100' : 'opacity-0',
            !_ctx.isExpand ? 'hidden' : '',
            'pro-transition-text !text-sm text-center uppercase px-2 text-[#5A4C42] logo-text',
          ])
        }, " Shosha Procurement System ", 2)
      ], 2),
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, key) => {
          return (_openBlock(), _createElementBlock("li", {
            key: key,
            class: "pro-nav-item-text group"
          }, [
            _createVNode(_component_router_link, {
              to: item.link
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: _normalizeClass([_ctx.currentRoute === item.link ? 'pro-nav-item-icon-active' : '', 'pro-nav-item-icon'])
                  }, null, 8, ["class"]))
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass([_ctx.isHover ? 'opacity-100' : 'opacity-0', _ctx.currentRoute === item.link ? 'pro-nav-item-icon-active' : '', 'pro-transition'])
                }, _toDisplayString(item.desc), 3)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "pro-nav-logout cursor-pointer group mb-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleIsExpand && _ctx.toggleIsExpand(...args)))
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_chevron_double_right_icon, {
              class: _normalizeClass(["h-8 w-8 ml-4 text-gray-500 group-hover:text-gray-700", _ctx.isExpand && 'rotate-180'])
            }, null, 8, ["class"])
          ]),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.isHover ? 'opacity-100' : 'opacity-0', 'pro-transition text-lg whitespace-pre ml-2 text-gray-500 group-hover:text-gray-700'])
          }, " Close Expand ", 2)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "pro-nav-logout cursor-pointer group",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_logout_icon, { class: "h-8 w-8 ml-4 fill-red-500 group-hover:fill-red-700" })
          ]),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.isHover ? 'opacity-100' : 'opacity-0', 'pro-transition text-lg whitespace-pre ml-2 text-red-500 group-hover:text-red-700'])
          }, "Logout", 2)
        ])
      ])
    ], 34)
  ], 2))
}